<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class TemplateEditorPageMixin extends Vue {
        async saveTemplate({jsonTemplate, htmlTemplate, info, localeCode, subjectTemplate}) {
            try {
                await this.$api.notificationTemplates.put(this.$route.params.id, {
                    jsonTemplate,
                    htmlTemplate,
                    info,
                    localeCode,
                    subjectTemplate,
                })
                this.$toast.success(this.$t('success_message.saved_successfully'))
                await this.$router.push({name: this.templatesPageName})
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            }
        }

        async saveNewTemplate(template) {
            try {
                await this.$api.notificationTemplates.post(template)
                this.$toast.success(this.$t('success_message.saved_successfully'))
                await this.$router.push({name: this.templatesPageName})
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            }
        }
    }

    export default TemplateEditorPageMixin
</script>
